import { render, staticRenderFns } from "./QuotationProposalCafezalInformation.vue?vue&type=template&id=8c5b92de&scoped=true"
import script from "./QuotationProposalCafezalInformation.vue?vue&type=script&lang=js"
export * from "./QuotationProposalCafezalInformation.vue?vue&type=script&lang=js"
import style0 from "./QuotationProposalCafezalInformation.vue?vue&type=style&index=0&id=8c5b92de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5b92de",
  null
  
)

export default component.exports